export const SHOW_ADL_ENTRY_POINTS = true;
// Resident schedules remain implemented but are temporarily hidden from the product UI.
export const SHOW_RESIDENT_SCHEDULES = false;
